namespace Portico.Services.Gateway.Models {
    export import models = Portico.Services.Gateway.Models;
}